import React from "react"
import { ButtonBase, ButtonProps } from "./ButtonBase"

export const ButtonNeutral = ({ className, ...props }: ButtonProps) => {
  return (
    <ButtonBase
      className={`shadow-buttonNuetral text-foreground-base bg-background-base hover:bg-background-base-hover active:bg-border-base disabled:shadow-buttonNuetral disabled:bg-baseHover ${className}`}
      {...props}
    />
  )
}
